import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import { addFilterUrl } from 'portaltransparencia-common/libs/AddFilter.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import PageHeader from '../components/PageHeader.react.js';
import CabecalhoEntidade from '../entidades/CabecalhoEntidade.react.js';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import * as actions from './Actions.js';
import RepasseDetalhe from './RepasseDetalhe.react.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';

const TIPO_RECEBIDO = 'R';
const TIPO_ENVIADO = 'E';

export class FormRepasseDetail extends Component {
  static propTypes = {
    repassesMes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    findRepassesRecebidosMes: PropTypes.func,
    findRepassesEnviadosMes: PropTypes.func,
    addErrorNotification: PropTypes.func.isRequired
  };

  componentDidMount() {
    const {
      location,
      findRepassesRecebidosMes,
      findRepassesEnviadosMes
    } = this.props;
    const params = getAllValuesFromUrlSearchParams(location);
    const filtro = this.montarFiltro();

    if (params.tipo == TIPO_RECEBIDO) {
      findRepassesRecebidosMes(filtro);
    } else {
      findRepassesEnviadosMes(filtro);
    }
  }

  onExporta = (exportType, openTab, windowParams) => {
    const { apiURL } = configuration;
    const { location, repassesMes, addErrorNotification } = this.props;

    if (!repassesMes.isEmpty()) {
      const params = getAllValuesFromUrlSearchParams(location);

      let repasse = '';
      repasse = addFilterUrl(repasse, `entidade=${params.entidade}`);
      repasse = addFilterUrl(repasse, `exercicio=${params.exercicio}`);
      repasse = addFilterUrl(repasse, `tipo=${params.tipo}`);
      repasse = addFilterUrl(repasse, `entidadeDestinoOrigem=${params.entidadeDestinoOrigem}`);

      if (params.conta) {
        repasse = addFilterUrl(repasse, `conta=${params.conta}`);
      }
      
      if (params.tipo == this.TIPO_ENVIADO && params.idContaCorrente) {
        repasse = addFilterUrl(repasse, `idContaCorrente=${params.idContaCorrente}`);
      }

      window.open(
        `${apiURL}/api/repasses/report/mes?${repasse}&exportType=${exportType}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  montarFiltro = function () {
    const { location } = this.props;
    const params = getAllValuesFromUrlSearchParams(location);

    let filter = '';
    filter = addFilterUrl(filter, `entidade=${params.entidade}`);
    filter = addFilterUrl(filter, `exercicio=${params.exercicio}`);
    filter = addFilterUrl(
      filter,
      `entidadeDestinoOrigem=${params.entidadeDestinoOrigem}`
    );

    if (params.conta) {
      filter = addFilterUrl(filter, `conta=${params.conta}`);
    }

    if (params.idContaCorrente) {
      filter = addFilterUrl(
        filter,
        `idContaCorrente=${params.idContaCorrente}`
      );
    }

    return filter;
  };

  render() {
    const { repassesMes, location } = this.props;
    const { tipo, mesInicial, mesFinal } = getAllValuesFromUrlSearchParams(
      location
    );

    return (
      <section>
        <Helmet title={'Repasses - Detalhado'} />

        <PageHeader location={location} />

        <CabecalhoEntidade />

        <Panel isForm expansible={false} tableResponsive>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacao modulo="3" />
            </Col>
            <Col xs={6}>
              <ExportButtonGroup onClick={this.onExporta} visible={true} />
            </Col>
          </Row>

          <BotaoImprimir />

          <RepasseDetalhe
            repasses={repassesMes}
            tipo={tipo}
            mesInicial={mesInicial ? parseInt(mesInicial) : undefined}
            mesFinal={mesFinal ? parseInt(mesFinal) : undefined}
          />
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    repassesMes: state.repasse.get('repassesMes')
  };
}

const allActions = {
  ...actions,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(FormRepasseDetail);
